import React from "react";
import { cn } from "../lib/utils";

export const LoadingIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
      className={cn("animate-spin motion-reduce:hidden", props.className)}
      ref={ref}
    >
      <path d="M22 12a10 10 0 1 1-6.91-9.51" />
    </svg>
  );
});

LoadingIcon.displayName = "LoadingIcon";
